var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8826 1.83107H5.22368V1.284C5.22368 0.982017 4.97861 0.736938 4.67662 0.736938C4.37463 0.736938 4.12956 0.982017 4.12956 1.284V1.83107H2.48836C1.58192 1.83107 0.847168 2.56582 0.847168 3.47226V15.5077C0.847168 16.4141 1.58192 17.1489 2.48836 17.1489H15.6179C16.5243 17.1489 17.2591 16.4141 17.2591 15.5077V3.47226C17.2591 2.56582 16.5243 1.83107 15.6179 1.83107H13.9767V1.284C13.9767 0.982017 13.7316 0.736938 13.4297 0.736938C13.1277 0.736938 12.8826 0.982017 12.8826 1.284V1.83107ZM16.165 6.20758V15.5077C16.165 15.8097 15.9199 16.0547 15.6179 16.0547H2.48836C2.18638 16.0547 1.9413 15.8097 1.9413 15.5077V6.20758H16.165ZM16.165 5.11345H1.9413V3.47226C1.9413 3.17027 2.18638 2.9252 2.48836 2.9252H15.6179C15.9199 2.9252 16.165 3.17027 16.165 3.47226V5.11345Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22377 11.1312C5.22377 11.4333 4.97881 11.6782 4.6767 11.6782C4.3746 11.6782 4.12964 11.4333 4.12964 11.1312C4.12964 10.8291 4.3746 10.5841 4.6767 10.5841C4.97881 10.5841 5.22377 10.8291 5.22377 11.1312Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22377 13.3194C5.22377 13.6215 4.97881 13.8665 4.6767 13.8665C4.3746 13.8665 4.12964 13.6215 4.12964 13.3194C4.12964 13.0173 4.3746 12.7724 4.6767 12.7724C4.97881 12.7724 5.22377 13.0173 5.22377 13.3194Z",
    fill: "#606060"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.412 8.9429C7.412 9.24501 7.16704 9.48997 6.86494 9.48997C6.56283 9.48997 6.31787 9.24501 6.31787 8.9429C6.31787 8.6408 6.56283 8.39584 6.86494 8.39584C7.16704 8.39584 7.412 8.6408 7.412 8.9429Z",
    fill: "#606060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.412 11.1312C7.412 11.4333 7.16704 11.6782 6.86494 11.6782C6.56283 11.6782 6.31787 11.4333 6.31787 11.1312C6.31787 10.8291 6.56283 10.5841 6.86494 10.5841C7.16704 10.5841 7.412 10.8291 7.412 11.1312Z",
    fill: "#606060"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.412 13.3194C7.412 13.6215 7.16704 13.8665 6.86494 13.8665C6.56283 13.8665 6.31787 13.6215 6.31787 13.3194C6.31787 13.0173 6.56283 12.7724 6.86494 12.7724C7.16704 12.7724 7.412 13.0173 7.412 13.3194Z",
    fill: "#606060"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60024 8.9429C9.60024 9.24501 9.35528 9.48997 9.05317 9.48997C8.75106 9.48997 8.5061 9.24501 8.5061 8.9429C8.5061 8.6408 8.75106 8.39584 9.05317 8.39584C9.35528 8.39584 9.60024 8.6408 9.60024 8.9429Z",
    fill: "#606060"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60024 11.1312C9.60024 11.4333 9.35528 11.6782 9.05317 11.6782C8.75106 11.6782 8.5061 11.4333 8.5061 11.1312C8.5061 10.8291 8.75106 10.5841 9.05317 10.5841C9.35528 10.5841 9.60024 10.8291 9.60024 11.1312Z",
    fill: "#606060"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60024 13.3194C9.60024 13.6215 9.35528 13.8665 9.05317 13.8665C8.75106 13.8665 8.5061 13.6215 8.5061 13.3194C8.5061 13.0173 8.75106 12.7724 9.05317 12.7724C9.35528 12.7724 9.60024 13.0173 9.60024 13.3194Z",
    fill: "#606060"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7885 8.9429C11.7885 9.24501 11.5435 9.48997 11.2414 9.48997C10.9393 9.48997 10.6943 9.24501 10.6943 8.9429C10.6943 8.6408 10.9393 8.39584 11.2414 8.39584C11.5435 8.39584 11.7885 8.6408 11.7885 8.9429Z",
    fill: "#606060"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7885 11.1312C11.7885 11.4333 11.5435 11.6782 11.2414 11.6782C10.9393 11.6782 10.6943 11.4333 10.6943 11.1312C10.6943 10.8291 10.9393 10.5841 11.2414 10.5841C11.5435 10.5841 11.7885 10.8291 11.7885 11.1312Z",
    fill: "#606060"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7885 13.3194C11.7885 13.6215 11.5435 13.8665 11.2414 13.8665C10.9393 13.8665 10.6943 13.6215 10.6943 13.3194C10.6943 13.0173 10.9393 12.7724 11.2414 12.7724C11.5435 12.7724 11.7885 13.0173 11.7885 13.3194Z",
    fill: "#606060"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9767 8.9429C13.9767 9.24501 13.7317 9.48997 13.4296 9.48997C13.1275 9.48997 12.8826 9.24501 12.8826 8.9429C12.8826 8.6408 13.1275 8.39584 13.4296 8.39584C13.7317 8.39584 13.9767 8.6408 13.9767 8.9429Z",
    fill: "#606060"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9767 11.1312C13.9767 11.4333 13.7317 11.6782 13.4296 11.6782C13.1275 11.6782 12.8826 11.4333 12.8826 11.1312C12.8826 10.8291 13.1275 10.5841 13.4296 10.5841C13.7317 10.5841 13.9767 10.8291 13.9767 11.1312Z",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e910dccc518f2085a60ff258e98d7c4c.svg";
export { ForwardRef as ReactComponent };